import { render } from "./MenuItem.vue?vue&type=template&id=cf6ab268"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__